<template>
    <v-dialog 
        ref="dialog"
        max-width="500"
    >
        <template v-slot:activator="{ props: activatorProps }">
            <v-list-item v-bind="activatorProps" style="background-color:#FFCDD2;">
                <v-list-item-title v-bind="activatorProps" style="color: #F44336;">
                    Anular
                </v-list-item-title>
            </v-list-item>
        </template>
  
        <template v-slot:default="{ isActive }">
            <v-card>
                <v-toolbar title="Anular solicitud" class="modal-header"></v-toolbar>
                <v-card-text>
                    <label>Por favor ingrese el motivo por el cual quiere anular esta solicitud:</label>
                    <v-text-field
                        v-model="anularMotivo"
                        outlined
                        rows="3"
                        clearable
                        required
                        class="asterisco"
                    ></v-text-field>
                    <v-container class="d-flex justify-center align-center">
                        <Loader v-if="cargando"></Loader>
                    </v-container>
                </v-card-text>
        
                <v-card-actions>
                <v-spacer></v-spacer>
                    <v-btn
                        id="boton-verde"
                        text="Cancelar"
                        @click="isActive.value = false"
                        :disabled="cargando"
                        :loading="cargando"
                    ></v-btn>                
                    <v-btn
                        id="boton-verde"
                        text="Anular"
                        @click="anularSolicitud"
                        :disabled="anularMotivo.length == 0 || cargando"
                        :loading="cargando"
                    ></v-btn>
                </v-card-actions>
            </v-card>
        </template>
    </v-dialog>

    <AlertComponent
        :title="alertTitle"
        :text="alertText"
        :alertType="alertType"
        :showAlert="showAlert"
        @close="showAlert = false"
    ></AlertComponent>
</template>

<style src="../assets/general.css"></style>

<script>
    import PrestacionService from '@/api/PrestacionService';
    import AlertComponent from './AlertComponent.vue';
    import Loader from './Loader.vue';

    const prestacionService = new PrestacionService();
    export default {
        components: {
            AlertComponent,
            Loader
        },
        props: {
            solicitudId: {
                type: Number,
                required: true
            },
        },
        data() {
            return {
                anularMotivo: '',
                username: '',
                alertTitle: '',
                alertText: '',
                alertType: '',
                showAlert: false,
                cargando: false,
            }
        },
        methods: {
            async anularSolicitud() {
                this.cargando = true;
                this.username = this.$store.getters.getUsername;
                const response = await prestacionService.anularSolicitud(this.solicitudId, this.username, this.anularMotivo);
                this.$refs.dialog.isActive = false;
                this.cargando = false;
                this.$emit('solicitud-anulada', response);
            }
        }
    }
</script>